/* global axios */
import ApiClient from './ApiClient';

class MetaCampaignsDashboardAPI extends ApiClient {
  constructor() {
    super('meta_campaigns/dashboard', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new MetaCampaignsDashboardAPI();
